export const CODIGO_ERROR_TIMBRES_PAC = 'PXC-TIM-002';
export const MENSAJE_ERROR_TIMBRADO =
	`[${CODIGO_ERROR_TIMBRES_PAC}] Hubo un error al timbrar el comprobante`;

const ERROR_TIMBRES_AGOTADOS_PAC = /^\s*2\s*;\s*2\s*;\s*Timbres agotados\b/i;

export function mensajeErrorTimbrado(message: unknown): string {
	if (
		typeof message === 'string' &&
		ERROR_TIMBRES_AGOTADOS_PAC.test(message)
	) {
		return MENSAJE_ERROR_TIMBRADO;
	}

	return typeof message === 'string' && message
		? message
		: MENSAJE_ERROR_TIMBRADO;
}
